import { Fragment } from "react";
import { format } from "date-fns";
import { useSignal } from "@preact/signals-react";
import { es } from "date-fns/locale";

import { CalendarIcon, AngleRightIcon, XMarkIcon } from "components/Icons";
import Calendar from "componentsv2/widgets/Calendar";
import { cn } from "tools/ui";

const baseCard =
  "h-12 cursor-pointer text-white justify-center w-18 active:scale-95";
const cardDate = "flex h-full p-1 mt-auto";
const cardNoDate = "text-center my-auto p-1 hover:bg-neutral-700 rounded-md";

function DateCard({ onChangeDate }) {
  const showPopFrom = useSignal(false);
  const showPopTo = useSignal(false);
  const selectedFrom = useSignal(null);
  const selectedTo = useSignal(null);

  function onClick(e, name) {
    if (name === "fromDate") {
      showPopFrom.value = true;
    } else {
      showPopTo.value = true;
    }
  }

  function onChange(_date, name) {
    if (name === "fromDate") {
      selectedFrom.value = _date;
    } else {
      selectedTo.value = _date;
    }
    const res = {
      fromDate: selectedFrom.value,
      toDate: selectedTo.value,
    };
    onChangeDate(res);
  }

  function onClear() {
    selectedFrom.value = null;
    selectedTo.value = null;
    onChangeDate({ fromDate: null, toDate: null });
  }

  function rawCardDate(name) {
    let cardComponent;
    let label;
    let sigValue;
    if (name === "fromDate") {
      label = "Desde";
      sigValue = selectedFrom.value;
    } else {
      label = "Hasta";
      sigValue = selectedTo.value;
    }

    if (sigValue) {
      const fmtDate = format(sigValue, "dd");
      const fmtMonth = format(sigValue, "MMM", { locale: es });
      const fmtWeekday = format(sigValue, "EEE", { locale: es });
      cardComponent = (
        <div
          data={sigValue}
          className={cardDate}
          onClick={(e) => onClick(e, name)}
        >
          <span className="text-2xl font-semibold my-auto">{fmtDate}</span>
          <div className="flex flex-col pl-2 text-xs my-auto">
            <span className="font-semibold uppercase text-amber-300">
              {fmtMonth}
            </span>
            <span className="text-white">{fmtWeekday}</span>
          </div>
        </div>
      );
    } else {
      cardComponent = (
        <div className={cardNoDate} onClick={(e) => onClick(e, name)}>
          <CalendarIcon className="mt-auto mx-auto size-5 fill-current" />
          <p className="text-xs mt-1">{label}</p>
        </div>
      );
    }
    return <div className={cn(baseCard)}>{cardComponent}</div>;
  }

  return (
    <Fragment>
      <div
        className="flex p-2 h-10 md:h-16 bg-neutral-800 rounded-md shadow-sm"
        id="date-card"
      >
        {rawCardDate("fromDate")}
        <div className="flex">
          <AngleRightIcon className="my-auto w-5 h-5 fill-current text-white" />
        </div>
        {rawCardDate("toDate")}
        {(selectedFrom.value || selectedTo.value) && (
          <button
            type="button"
            title="Limpiar fechas"
            onClick={onClear}
            className="flex my-auto ml-1 p-1 rounded-md text-neutral-300 hover:text-white hover:bg-neutral-700 active:scale-95 cursor-pointer"
          >
            <XMarkIcon className="size-5 fill-current" />
          </button>
        )}
      </div>
      <Calendar
        name="fromDate"
        value={selectedFrom.value}
        onSelect={onChange}
        show={showPopFrom}
      />
      <Calendar
        name="toDate"
        value={selectedTo.value}
        onSelect={onChange}
        show={showPopTo}
      />
    </Fragment>
  );
}

export default DateCard;
